// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import moment from 'moment-timezone';
import { credits } from 'Utils/numberFormat';

const PERIOD_NAMES: Record<IOrgStatsPeriod['kind'], string> = {
  last12Months: 'Last 12 months',
  plan: 'This plan',
};

// the period every Plan Usage figure counts, the header's own: "Last 12 months: Oct 20, 2025 to Oct 20, 2026"
export const planUsagePeriodText = (period?: IOrgStatsPeriod | null) => {
  if (!period) return '';
  const day = (iso: string) => moment.utc(iso).format('MMM D, YYYY');
  return `${PERIOD_NAMES[period.kind]}: ${day(period.start)} to ${day(period.end)}`;
};

// what the header's figure holds beyond the period's placed orders: credits carried over or adjusted when it holds
// more, orders the balance does not count (a reset at renewal, an adjustment) when it holds less; nothing when the
// two agree or there is no header figure
export const carriedOverText = (carriedOverOrAdjusted?: number | null) => {
  if (typeof carriedOverOrAdjusted !== 'number' || Math.abs(carriedOverOrAdjusted) < 0.005) return '';
  return carriedOverOrAdjusted > 0
    ? `Includes ${credits(carriedOverOrAdjusted)} credits carried over or adjusted outside orders`
    : `${credits(-carriedOverOrAdjusted)} credits of these orders are not counted in the balance (reset or adjusted)`;
};
